import { TabsList } from 'components'
import { useSelector } from 'store/store'

import GeneralInfoTab from './components/GeneralInfoTab'
import InvoicesTable from './components/InvoicesTable'
import MaterialsTab from './components/MaterialsTab'
import ShipmentTab from './components/ShipmentTab'
import TextAndNDTab from './components/TextAndNDTab'
import * as S from './styled'

interface OvDetailsTabsProps {
  hasShipment?: boolean
  isBilled?: boolean
}
const OvDetailsTabs = ({ hasShipment = false, isBilled = false }: OvDetailsTabsProps) => {
  const { ovInitialTab } = useSelector((state) => state.structure)
  const { isSampleOrder } = useSelector((state) => state.salesOrder)
  return (
    <S.Wrapper>
      <TabsList initialTab={ovInitialTab}>
        <TabsList.Tab label="Informações gerais">
          <GeneralInfoTab />
        </TabsList.Tab>
        <TabsList.Tab label="Material">
          <MaterialsTab />
        </TabsList.Tab>
        <TabsList.Tab label={isSampleOrder ? 'Textos' : 'Textos e ND'}>
          <TextAndNDTab />
        </TabsList.Tab>
        <TabsList.Tab hidden={!hasShipment && !isBilled} label="Remessa">
          <ShipmentTab />
        </TabsList.Tab>
        <TabsList.Tab hidden={!isBilled} label="Faturamento">
          <InvoicesTable />
        </TabsList.Tab>
      </TabsList>
    </S.Wrapper>
  )
}

export default OvDetailsTabs
